function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#212121",
  fillRule: "evenodd",
  d: "M13 4 8 2 3 4v18h10zM7 20H5v-2h2zm0-4H5v-2h2zm0-4H5v-2h2zm0-4H5V6h2zm4 12H9v-2h2zm0-4H9v-2h2zm0-4H9v-2h2zm0-4H9V6h2zm10 0-3-2-3 2v14h6zm-2 2h-2v2h2zm0 4h-2v2h2zm0 4h-2v2h2z"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/location/ic-city.svg";
export { SvgComponent as ReactComponent };